export const SET_MAIN_SESSION_ID = 'SESSION/SET_MAIN_SESSION_ID';
